/**
 * Micromark extension for :emoji: inline syntax.
 */
export { gemoji } from './syntax';
